const { SIMPLE, ASYNC } = require('../utils/redux-helpers');

module.exports = {
    CLEAR: SIMPLE,
    SET_ALL_MESSAGES_SORTING_TYPE: SIMPLE,
    ADD_TWILIO_USER: ASYNC,
    REMOVE_TWILIO_USER: ASYNC,
    SET_COLLAPSE_HEADERS_DMS: SIMPLE,
    SET_COLLAPSE_HEADERS_GROUPS: SIMPLE,
    ADD_REACTION: ASYNC,
    REMOVE_REACTION: ASYNC
};
